"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e } from "react";
import t from "../components/Icon/SvgIcon.js";
const i = (l) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.6 12a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 0 1 19.2 0",
        clipRule: "evenodd"
      }
    )
  }
), n = e(i);
export {
  n as DotFilled,
  n as default
};
